// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2QLUW","footer":"ChangeClinic_footer__33aDF"};